var exports = {
  "x6": "DiscoveryButton.module__button___LVhFSV",
  "td": "DiscoveryButton.module__iconText___LVhFSV",
  "yF": "DiscoveryButton.module__iconTextSelected___LVhFSV",
};

module.exports = exports;
